import React from 'react';

import VistaEtiquetas from '../Compartidas/VistaEtiquetas';

import EtiquetasHelper from '../../Helpers/Etiquetas';

const USADO_EN = { singular: 'curso', plural: 'cursos' };

const Etiquetas = () => (
    <VistaEtiquetas
        helper={EtiquetasHelper}
        seccion='Cursos'
        encabezado='Etiquetas de cursos'
        usadoEn={USADO_EN}
        ubicacion='Se asigna a los cursos al editarlos.'
    />
);

export default Etiquetas;
